import "./ionic.scss";
import { setupIonicReact } from "@ionic/react";

setupIonicReact();
